module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0742b_banner_800x600.f72f5933.png";